import { FaMedal } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";

import LazyImage from "./LazyImage";

// Certificate presented as an achievement "badge".
const BadgeCard = ({ badge }) => (
  <article className="badge-card">
    <a
      className="badge-thumb"
      href={badge.url}
      target="_blank"
      rel="noreferrer"
      title={badge.title}
    >
      <LazyImage src={badge.image} alt={badge.title} />
      <span className="badge-medal">
        <FaMedal />
      </span>
      <span className="badge-issuer">{badge.issuer}</span>
    </a>
    <div className="badge-info">
      <h3 className="badge-title">{badge.title}</h3>
      <div className="badge-skills">
        {badge.skills.map((s) => (
          <span key={s} className="badge-skill">
            {s}
          </span>
        ))}
      </div>
      <a className="badge-link" href={badge.url} target="_blank" rel="noreferrer">
        View credential <FiExternalLink />
      </a>
    </div>
  </article>
);

export default BadgeCard;
